import { IconButton, motion } from '@hover/blueprint';
import { iZoomIn } from '@hover/icons';
import { AnimatePresence } from 'framer-motion';
import React from 'react';

const MotionIconButton = motion(IconButton);

interface ZoomButtonProps {
  onClick: () => void;
  isVisible?: boolean;
}

const ZoomButton = ({ onClick, isVisible = true }: ZoomButtonProps) => (
  <AnimatePresence initial={false}>
    {isVisible && (
      <MotionIconButton
        borderRadius="350"
        bottom={{ base: 400, tablet: 600 }}
        colorScheme="light"
        icon={iZoomIn}
        label="zoom"
        left={{ base: 400, tablet: 600 }}
        onClick={onClick}
        position="absolute"
        transition={{ duration: 0.3 }}
        variant="glass"
        zIndex={3}
      />
    )}
  </AnimatePresence>
);

export { ZoomButton };
